import React from 'react';
import { priceFormatter } from '../utils/helpers';

const Price = ({ product, variant, cart = false, separateCurrency, productPage, searchPage, mainProduct, variantPrice, locationCategory }) => {

  if (
    (typeof product === 'undefined' || !product) &&
    (typeof variant === 'undefined' || !variant)
  ) {
    return null;
  }

  let min = Infinity;
  let max = 0;
  let compare = 0;
  let priceRange = 0;

  if (product) {
    priceRange = product.priceRangeV2 || product.priceRange;
    min = priceRange.minVariantPrice.amount;
    max = priceRange.maxVariantPrice.amount;

    if (productPage) {
      if (min !== max) {
        compare = priceRange.minVariantPrice.compareAtPrice || 0;
      } else {
        max = min;
      }
    }
  }

  if (variant && searchPage && !mainProduct) {
    min = max = isNaN(variantPrice) ? variant.price.amount : variantPrice;
    compare = variant.compareAtPrice || 0;
  } else if (variant && !productPage) {
    min = isNaN(variant.price) ? variant.price.amount : variant.price;
    max = min;
    compare = variant.compareAtPrice;
  }

  const maybeCurrency = (price) => {
    return (
      separateCurrency ? (
        <>
          <span className="currency">$</span>
          {priceFormatter(price).replace('$', '')}
        </>
      ) : (
        priceFormatter(price)
      )
    );
  }

  // const showPriceRange = locationCategory && variant?.selectedOptions[0].name !== 'Cutting Service';

  if (locationCategory && variant?.selectedOptions[0].name === 'Cutting Service') {
    return (
      <div className="Product__price">
        <span className="Product__price__min">{maybeCurrency(min)}</span>
      </div>
    );
  } else if (productPage) {
    return (
      <div className="Product__price">
        <span className="Product__price__min">{maybeCurrency(min)}</span>
        {min !== max && (
          <>
            <span className="Product__price__dash">&nbsp;-&nbsp;</span>
            <span className="Product__price__max">{maybeCurrency(max)}</span>
          </>
        )}
      </div>
    );
  } else {
    return (
      <div className="Product__price">
        {min !== max && (
          <>
            <span className="Product__price__min">{maybeCurrency(min)}</span>
            <span className="Product__price__dash">&nbsp;-&nbsp;</span>
          </>
        )}
        {compare !== 0 && compare !== null && !cart && (
          <del className="Product__price__compare">{maybeCurrency(compare)}</del>
        )}
        <span className="Product__price__max">{maybeCurrency(max)}</span>
      </div>
    );
  }
}

export default Price;
